import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from 'app/services/translation-loader.service';
import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { environment } from '~env';
import { locale as english } from './i18n/en';
import { locale as french } from './i18n/fr';
import { NotificationStatus, ProjectionNotification } from './notifications.models';

enum ConnectionStatusEnum {
  NOT_CONNECTED,
  CONNECTING,
  CONNECTED,
  ERROR,
}

@Injectable({
  providedIn: 'root',
})
export class ProjectionNotificationsService {

  private _notification$ = new Subject<ProjectionNotification>();

  private _status: ConnectionStatusEnum = ConnectionStatusEnum.NOT_CONNECTED

  private _connection: HubConnection

  constructor(private translate: TranslateService, translationLoader: FuseTranslationLoaderService) {
    translationLoader.loadTranslations(english, french);
  }

  connect(userEmail: string): Observable<any> {
    const res = new Subject<void>();

    this._connection = new HubConnectionBuilder()
      .withUrl(`${environment.signalRApi}?oid=${userEmail}`)
      .configureLogging(LogLevel.Information)
      .build();

    this._status = ConnectionStatusEnum.CONNECTING;

    this._connection.start().then(
      () => {
        this._status = ConnectionStatusEnum.CONNECTED
        res.next();
      },
      (err) => {
        this._status = ConnectionStatusEnum.ERROR
        res.error(err);
      },
    )

    return res;

  }

  watch(): Observable<ProjectionNotification> {

    if (this._status !== ConnectionStatusEnum.CONNECTED) {
      throw new Error('Not Connected to SignalR');
    }
    this._connection.on('ReceiveMessage', (data: { userId: string, text: string }) => {
      this._notification$.next({
        status: NotificationStatus.Success,
        title: this.translate.instant(`projectionEvent.${data.text}`),
        eventType: data.text,
      })
    })

    return this._notification$;
  }

  when(eventType: string): Observable<any> {
    return this._notification$.pipe(
      filter(notif => notif.eventType === eventType),
    )
  }

}